const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      ServicesTemplate {
        titleStories
        successCards {
          title
          description
        }
      }
    }
  }
`;
export default fetchData;
